import React from 'react';
import _ from 'underscore';

import navigateToURL from 'lib/navigateToURL';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default class PrintButton extends React.Component {
  openPrint = (): void => {
    navigateToURL(window.location.pathname);
    _.defer(() => {
      window.print();
    });
  };

  render(): JSX.Element {
    return (
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.SMALL}
        icon="format-print"
        onClick={this.openPrint}
      />
    );
  }
}
